// brandTheme.js — apply a collector's brand config to the customer-facing UI.
//
// The share app was originally single-brand; the rebrand hardcoded RavePilot
// identity into the header/recorder and the accent into CSS vars. This module
// restores multi-tenancy: pages call applyBrandTheme(collector.brand) after
// the submission payload loads, and brand-aware components take a `brand`
// prop for the logo. Defaults are RavePilot, so the RavePilot tenant (and any
// collector without brand config) renders exactly as before.

export const DEFAULT_LOGO = 'https://share.ravepilot.com/ravepilot-logo.png';

function shade(hex, f) {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const c = (v) => Math.max(0, Math.min(255, Math.round(v * f)));
  const r = c((n >> 16) & 255), g = c((n >> 8) & 255), b = c(n & 255);
  return '#' + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0');
}

export const DEFAULT_SHARE_TITLE = 'Got 30 seconds? Share your story.';

export function applyBrandTheme(brand) {
  const t = (brand && brand.share_title && String(brand.share_title).trim()) || DEFAULT_SHARE_TITLE;
  try { document.title = t; } catch {}
  const color = brand && /^#[0-9a-f]{6}$/i.test(brand.primary_color || '') ? brand.primary_color : null;
  if (!color) return;
  const root = document.documentElement.style;
  // var names are historical — they're the app-wide accent
  root.setProperty('--accent', color);
  root.setProperty('--accent-hover', shade(color, 1.12) || color);
  root.setProperty('--accent-press', shade(color, 0.78) || color);
  root.setProperty('--ravepilot-orange', color);
  root.setProperty('--ravepilot-orange-press', shade(color, 0.78) || color);
  root.setProperty('--vt-ico', color);
}

export function brandLogo(brand) {
  return (brand && brand.logo_url) || DEFAULT_LOGO;
}

export function brandName(brand) {
  return (brand && brand.name) || 'RavePilot';
}
